<template>
<div class="card">
<div @click="goLink" :class="`d-flex flex-column justify-content-start align-items-center h-75`" style="position: absolute; top: 20px">
    <span  class="title-card"
      ><a v-if="!comprado">0{{ id }}</a>
      <span class="purple-gradient" v-if="comprado">Adquirido</span>
    </span>

    <span v-if="foto" class="centralizar-img">
      <img v-lazy="foto" :src="foto"  />
    </span>
    <div class="text-center">
      <span class="text-center title"
        ><b v-lazy="nome"> {{ nome ? nome : "name" }}</b></span
      ><br />
      <span class="text-center description">
        {{
          descricao == "null"
            ? subtitulo
            : descricao.length > 12
            ? descricao.substring(0, 12) + "..."
            : descricao
        }}
      </span>
    </div>

  
  </div>
    <div class="d-flex w-100 justify-content-around align-items-center " style="position: absolute; bottom: 20px">
      <div v-if="likes != undefined" class="quantidade">
        <div
          @click="toggleLike"
          :class="`badge curtidas  ${curtido ? 'green-gradient' : ''}`"
        >
          <i class="fa fa-thumbs-up"></i>
        </div>
        {{ likes }}
      </div>

      <!-- <div  @click="$router.push({ path: `${link}`, query: { comentarios: 'aberto' }}, () => {})" v-if="comentarios != undefined" class="quantidade">
        <div :class="`badge comentarios`"><i class="fa fa-comment"></i></div>
        {{ comentarios }}
      </div> -->
      <div @click="goLink" :class="`btn-play`">
        <i class="fa fa-play"></i>
      </div>
    </div>
</div>
  
</template>
<script>
export default {
  name: "CardGenerico",
  props: {
    nome: String,
    id: Number,
    subtitulo: String,
    descricao: String,
    foto: String,
    likes: Number,
    comentarios: Number,
    link: String,
    comprado: Boolean,
    curtido: Boolean,
    tipo: Boolean
  },
  methods: {
    goLink(){
      ////////// Valor verdadeiro quer dizer que é uma revista, falso são respostas
      if(this.tipo == true){
        this.$router.push({path: `pdfviewer/show_magazine/${this.id}`}).catch(err => {
            alert('tag', err)
        })
      }else{
        this.$router.push({path: `pdfviewer/show_answare/${this.id}`}).catch(err => {
            alert('tag', err)
        })
      }
        
    },
    toggleLike() {
      let self = this;
      if(localStorage.getItem('t')){
        if (this.curtido) {
        self.$emit("toggle-like", { id: this.id, like: false });

        this.$axios
          .get(`/descurtir/passatempos/${this.id}`)
          .then((res) => res.data)
          .then(() => {})
          .catch(() => {
            this.$store.commit("setStateModal", {
              visible: true,
              title: "Erro",
              type: "error",
              message: "Erro ao descutir passatempo",
            });
          });
      } else {
        this.$axios
          .get(`/curtir/passatempos/${this.id}`)
          .then((res) => res.data)
          .then(() => {
            self.$emit("toggle-like", { id: this.id, like: true });
          })
          .catch(() => {
            this.$store.commit("setStateModal", {
              visible: true,
              title: "Erro",
              type: "error",
              message: "Erro ao curtir passatempo",
            });
          });
      }
      }else{
        this.$store.commit("setStateModal", {
            visible: true,
            title: "Atenção",
            type: "warning",
            message: "Faça login para continuar.",
            callbackOk: async () => {
              this.$router.push({ path: '/login' })
            },
            callbackCancel: () => this.$store.commit("setStateModal", {visible:false})
          });
      }
      
    },
  },
};
</script>
<style scoped>
.card {
  width: 90%;
  height: 50vh !important;
  position: relative;
  background-color: white;
  border-radius: 0;
  border: none;
  padding: 10px 5px 20px 5px;
  box-shadow: 6px 6px 10px rgba(0, 0, 0, 0.100);
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 15px;
  transition: ease 1s;
}

.card:hover{
  transform: scale(1.01);
}

.purple-gradient {
  background-color: #7f53ac;
  background-image: linear-gradient(315deg, #7f53ac 0%, #647dee 74%);
  font-size: 15px;
  text-transform: uppercase;
  padding: 5px 10px;
  color: white;
  transition: ease 1s;
}

.purple-gradient:hover {
  padding: 5px 15px;
}

.green-gradient {
  background-color: #5bac53;
  background-image: linear-gradient(315deg, #77ac53 0%, #69ee64 74%);
}

.gray-filter {
  filter: grayscale(8);
}
.centralizar-img {
  display: flex;
  align-items: center;
  justify-content: center;
}
.centralizar-img img {
  width:50% !important;
  cursor: pointer;
}
@media(min-width:1367px){
.centralizar-img img {
  width:80% !important;
}}
@media(min-width:1500px){
.centralizar-img img {
  width:80% !important;
}
}
/* img {
} */

.title-card {
  text-align: center;
}


.title{
  line-break: auto;
  font-size: 1.2em;
}


.description {
  line-break: auto;
  text-align: center;
  font-size: 1em;
  font-family: "Agency FB Regular" !important;
  margin-top: 12px;
  margin-bottom: 15px;
}

.description b {
  font-size: 14px;
  font-family: "Agency FB" !important;
}
.badge {
  width: 40px;
  height: 40px;
  border-radius: 60px;
  position: absolute;
  top: -20.5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.badge i {
  font-size: 12px;
  color: white;
}

.btn-play {
  width: 35px;
  height: 35px;
  background-color: black;
  transform: rotate(45deg);
  cursor: pointer;
  transition: ease 1s;
}

.btn-play:hover {
  width: 40px;
  height: 40px;
}

.btn-play i {
  color: white;
  position: absolute;
  transform-origin: 0 0;
  top: 50%;
  left: 50%;
  transform: rotate(-45deg) translate(-35%, -50%);
  font-size: 10px;
}

.quantidade {
  position: relative;
  background-color: rgb(216, 216, 216);
  width: 40px;
  height: 38px;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  font-size: 14px;
  align-items: flex-end;
}

.comentarios {
  background-color: black;
}
.curtidas {
  background-color: #4e534d;
}
</style>